import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import IconDecr from 'material-ui/svg-icons/content/remove';
import IconIncr from 'material-ui/svg-icons/content/add';
import { getPictureUrlFromBase64 } from './../../../../../utils/index';
import { red600 } from 'material-ui/styles/colors';

const CategoryAccessory = props => {
  const { accessories, id, pictureUrl,  status, qty, handleQty, incrQty, decrQty } = props;
  let cardStyle = {
    height: '280px',
    width: '240px',
    marginLeft: '12px',
    // paddingLeft: '16px',
    // paddingRight: '16px',
    paddingBottom: '16px',
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid transparent'
  }
  cardStyle = qty > 0 ? { ...cardStyle, border: '1px solid #F44336' } : cardStyle;

  const photoStyle = {
    display: 'flex',
    height: '200px',
    width: '220px',
    backgroundImage: 'url("' + pictureUrl + '")',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }
  const descrStyle = {
    color: '#fff',
    width: qty === 0 ? '242px' : '240px', //to overlap transparent border
    // width: '242px',
    marginTop: '-1px',
    fontSize: '15px',
    height: '68px',
    background: '#F44336',
    borderTopRightRadius: '2px',
    borderTopLefttRadius: '2px',
    padding: '8px'
  }
  return (
    <div style={{marginTop: '20px', display: 'flex', flexWrap: 'wrap'}}>
      <Paper style={cardStyle} transitionEnabled={false}>
        <div style={descrStyle}>
          {accessories[id].descr}
        </div>
        <div style={photoStyle}></div>
        {status === 'prepare' &&
          <div style={{display: 'flex', justifyContent: 'center'}}>
            <IconButton
              onClick={
                () => {
                  decrQty(id);
                }
              }
            >
              <IconDecr />
            </IconButton>
            <TextField
              underlineFocusStyle={{borderColor: red600 }}
              value={qty}
              id={`${id}catAccQty`}
              style={{width: '50px'}}
              inputStyle={{textAlign: 'center'}}
              // defaultValue={0}
              onChange={
                (e, v) => {
                  handleQty(id, v);
                }
              }
            />
            <IconButton
              onClick={
                () => {
                  incrQty(id);
                }
              }
            >
              <IconIncr />
            </IconButton>
          </div>
        }
      </Paper>
    </div>
  );
}

CategoryAccessory.propTypes = {
  id: PropTypes.string,
  categoryAccessoriesIds: PropTypes.object
}

const mapStateToProps = (state, ownProps) => {
const { accessories, pictures } = state;
const { descr, picture } = accessories[ownProps.id];
const pictureUrl = picture ? getPictureUrlFromBase64(pictures[picture]) : '';
  return { pictureUrl, descr, accessories };
}

export default connect(
  mapStateToProps
)(CategoryAccessory);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/accessories-kiosk/item.js